/*
 * Copyright (c) 2010, 2023 BSI Business Systems Integration AG
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 */
import {PropertyChangeEvent, WidgetEventMap} from '../index';

export interface SliderEventMap extends WidgetEventMap {
  'propertyChange:value': PropertyChangeEvent<number>;
  'propertyChange:minValue': PropertyChangeEvent<number>;
  'propertyChange:maxValue': PropertyChangeEvent<number>;
  'propertyChange:step': PropertyChangeEvent<number>;
  'propertyChange:tabbable': PropertyChangeEvent<boolean>;
}
